import { mainStore } from '@dinosband/bv-utils'
import { MessageSummary } from '@dinosband/bv-main-schema/dist/types'
import { BvSubscriber } from './manager/subscriber'

export class MessageSummarySubscriber extends BvSubscriber<MessageSummary> {

  chatRoomId: number

  constructor (chatRoomId: number, callback: (value: MessageSummary | MessageSummary[]) => void) {
    super(callback)
    this.chatRoomId = chatRoomId
  }

  protected async query (mesgIds?: number[]) {
    if (!mesgIds?.length) {
      return
    }
    return await mainStore.readMessageSummaries(mesgIds)
  }

  protected async subscribe () {
    return await mainStore.subscribeOnMessageSummaryUpdated(this.chatRoomId, (value) => { this.callback(value) })
  }

}
